export const team = [
  {
    id: "claire",
    name: "Claire Gaillardou",
    role_fr: "Facilitatrice — Directrice de l'élémentaire",
    role_en: "Facilitator — Director of the primary school",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/3b5cb7fb5e9151e9_CLAIRE%20ROLES.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/fdd77a5e6cf2bca8_Claire%201.png",
  },
  {
    id: "emilie",
    name: "Émilie Clozier Libercé",
    role_fr: "Facilitatrice — Directrice du secondaire",
    role_en: "Facilitator — Director of the secondary school",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/f2057e299fd78345_emili%202.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/2d400540992d699e_EMILIE%201.png",
  },
  {
    id: "louise",
    name: "Louise Barnard",
    role_fr: "Facilitatrice — Directrice adjointe",
    role_en: "Facilitator — Deputy director",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/2c0b752e7799ddea_LOUISE%202.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/e443420c528ab893_louise%201.png",
  },
  {
    id: "magali",
    name: "Magali Dupuy",
    role_fr: "Facilitatrice — Enseignante (SVT, espagnol)",
    role_en: "Facilitator — Teacher (life sciences, Spanish)",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/e1e1cc6a3e798402_MAG%202.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/1bd2fb454ec21af9_mag%201.png",
  },
  {
    id: "robin",
    name: "Robin Spencer",
    role_fr: "Facilitateur — Professeur d'art, design et musique",
    role_en: "Facilitator — Art, design and music teacher",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/f1d5c385eb068082_ROBIN%20ROLES.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/b55d408c9131a666_ROBIN%201.png",
  },
  {
    id: "sebastien",
    name: "Sébastien Janin",
    role_fr: "Facilitateur — Directeur de l'ALAE",
    role_en: "Facilitator — Director of the after-school program",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/1ff8f2f7d0701285_SEB%202.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/789941140599b9e6_seb%201.png",
  },
  {
    id: "guilhem",
    name: "Guilhem Gaillardou",
    role_fr: "Facilitateur",
    role_en: "Facilitator",
    rolesImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/55228daa16319db8_guilhem.png",
    interestsImage:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/d58831e3ce847175_guilhem%20a.png",
  },
];
